import type { PopperPlacementType } from "@mui/material";

export const DEFAULT_PLACEMENT: PopperPlacementType = "bottom-start";

export const DEFAULT_OFFSET: [number, number] = [0, 5];

export const GROW_STYLE = { transformOrigin: "top left" } as const;

export const GROW_TIMEOUT = 250;
